module.exports = __webpack_public_path__ + "img/20_131.2c535717.png";